import { render, staticRenderFns } from "./blocks.vue?vue&type=template&id=048ab198&lang=pug&"
import script from "./blocks.vue?vue&type=script&lang=js&"
export * from "./blocks.vue?vue&type=script&lang=js&"
import style0 from "./blocks.vue?vue&type=style&index=0&id=048ab198&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports